import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroVisual from '@/components/landing/hero-visual'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <section
                id='hero'
                className='relative h-svh min-h-[560px] w-full overflow-hidden bg-[#0B1E36] landscape:h-[min(56.25vw,100svh)] landscape:min-h-[320px]'
            >
                <HeroVisual />
            </section>
        </Layout>
    )
}

export default Home
